/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import Checker from "vux/src/components/checker/checker.vue";
import CheckerItem from "vux/src/components/checker/checker-item.vue";
export default {
  components: {
    Checker: Checker,
    CheckerItem: CheckerItem
  },
  props: {
    title: {
      type: [String]
    },
    value: {
      type: [Array]
    },
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      realValue: [] // 拓展搜索 显示

    };
  },
  watch: {
    value: function value(val) {
      var _this = this;

      if (JSON.stringify(val) !== JSON.stringify(this.realValue)) {
        if (val.length > 0) {
          this.value.forEach(function (item) {
            if (!_this.realValue.some(function (item2) {
              return item2.value === item;
            })) {
              var obj = _this.data.filter(function (item3) {
                return Number(item3.value) === Number(item);
              })[0];

              _this.realValue.push(obj);
            }
          });
        } else {
          this.realValue = [];
        }
      }
    },
    realValue: function realValue(val) {
      var value = this.realValue.length > 0 ? this.realValue.map(function (item) {
        return item.value;
      }) : this.realValue;
      this.$emit('input', value);
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.value) {
      this.value.forEach(function (item) {
        if (!_this2.realValue.some(function (item2) {
          return item2.value === item;
        })) {
          var obj = _this2.data.filter(function (item3) {
            return Number(item3.value) === Number(item);
          })[0];

          _this2.realValue.push(obj);
        }
      });
    }
  }
};